var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrice = function SvgPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#price_svg__a)",
    d: "M8 9.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#price_svg__b)",
    d: "M3 14.5a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "price_svg__a",
    x1: 14.5,
    x2: 14.5,
    y1: 16,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "price_svg__b",
    x1: 9.5,
    x2: 9.5,
    y1: 21,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgPrice;